import img1 from "../assets/img/menu/ginger-soup.png"
import img2 from "../assets/img/menu/spinach-soup.png";
import img3 from "../assets/img/menu/carrot-ginger-soup.png";
import img4 from "../assets/img/menu/sago-porridge.png";
import img5 from "../assets/img/menu/finger-miller-ragi-malt.png";
import img6 from "../assets/img/menu/finger millet ambali.png";
import img7 from "../assets/img/menu/jawar-porridge.png";
import img8 from "../assets/img/menu/oats-porridge.png"


const FoodData=
[
    {
      "id":1,
      "name":"Ginger Garlic Soup",
      "image":img1 ,
      "description": "Garlic is good for your heart and ginger has numerous health benefits",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"Heat olive oil over medium heat in a large soup pot. Add ginger and garlic, and cook for 2-3 minutes until fragrant.Add vegetable broth, salt, and pepper. Bring to a boil and  cook for ten minutes. Remove from heat, and serve!",
     "phb":"Immune System Support,Anti-Inflammatory Properties,Digestive Aid,Cardiovascular Health,Respiratory Health,Weight Management",
     "nutri":"Vitamins (such as Vitamin C, Vitamin B6), Minerals (such as Iron, Calcium, Potassium), Allicin (from garlic), Gingerol (from ginger), Amino Acids",

    },
    {
      "id":2,
      "image":img2 ,
      "name":"Spinach Soup",
      "description": "Spinach is a good source of vitamin and, Vitamin C, vitamin k, iron, folate, and potassium.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"Fresh, canned or frozen spinach can be used, and the spinach can be used whole, puréed or chopped. Additional ingredients can include onion, green onion, carrot, celery, tomatoes, potatoes, lemon juice, olive oil, seasonings, salt and pepper.",
      "phb":"Regulates Blood Pressure, Contributes to Heart Health, Promotes Healthy Skin, Aids in Weight Management, Improves Vision Health",
      "nutri":"Iron, Vitamin A, C, B6, B9 and K, Folate, Calcium, Magnesium, Zinc, Manganese, Protein",
    
     
  
    },
    {
      "id":3,
      "image":img3 ,
      "name":"Carrot Ginger Soup",
      "description": "A vitamin rich soup made with fresh carrots and grated ginger thickened with super healthy jowar flour.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
         "des":"All you need are carrots, onions, butter, a little ginger, a few strips of orange peel, some stock, water, and salt. The soup comes together in less than an hour, prep included.",
         "phb":"Supports digestion, Promotes skin health, Improves heart health, Aids in weight management, Regulates blood sugar levels, Anti-inflammatory properties, Supports eye health.",
         "nutri":"Vitamin A, Vitamin C, Potassium, Dietary fiber, Antioxidants (beta-carotene), Iron, Magnesium, Vitamin K, Vitamin E,B-vitamins (B6, niacin)"
      
    },
    {
      "id":4,
      "image":img4 ,
      "name":"Saggubiyyam Jaava",
      "description": "This antioxidant rich porridge is naturally gluten-free and helps to improve digestion, strengthens muscles and uplifts heart functions.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"Boil water in a pan add the soaked sago and in medium low flame cook till the sago is transparent and soft.Switch off the stove let the sago cool completely.Add needed curd and water as needed to dilute, mix well and serve.Best summer drink to beat the heat.",
      "phb":"Gluten-Free, Help Regulate Blood Sugar Levels, Satiety and Reduced Caloric Intake, Provides Sustained Energy, Rich in Dietary Fiber, Promotes Digestive Health",
      "nutri":"Dietary Fiber, Carbohydrates, Vitamins (B-complex), Minerals (Calcium, Iron, Magnesium, Phosphorus, Potassium), Protein, Healthy Fats"
    },
    {
      "id":5,
      "image":img5 ,
      "name":"Ragi Malt",
      "description": "An exotic beverage made with organic ragi flour, mixed with little amount of milk and sweetened with desi jaggery served with a final touch of cardamom powder. ragi is ranked as millet #1 as it has numerous health benefits viz, has loads of calcium, prevents skin from ageing, helps in weight loss, prevents colon cancer and also good for your hair.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"To make Ragi Malt, mix ragi flour with water, ensuring no lumps. Cook the mixture on low heat, stirring continuously. Add milk, sweetener, and a pinch of salt. Continue stirring until it reaches a smooth consistency. Flavor with cardamom or vanilla. Serve warm.",
      "phb":"Provides Essential Amino Acids, Supports Cardiovascular Health, Regulates Blood Pressure, High in Antioxidants, Enhances Digestive Health, Manages Diabetes, Boosts Bone Health",
      "nutri":"Calcium, Iron, Magnesium, Phosphorus, Potassium, Vitamin B1 (Thiamine), Vitamin B2 (Riboflavin),Vitamin B3 (Niacin),Vitamin B6, Folate, Vitamin E."
    },
    {
      "id":6,
      "image":img6 ,
      "name":"Ragi Ambali",
      "description": "A super healthy porridge which has its roots from chennai, made with organic ragi flour, fermented rice and spiced buttermilk. this drink is known to work as a general refresher and hydrates when tired. Also believed to help control diabetes.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"To prepare Ragi Ambali, mix ragi flour with water, ensuring a smooth consistency. Add buttermilk and salt, and bring it to a gentle boil. Pour this tempering into the ragi mixture, stirring well. Simmer until it achieves a porridge-like consistency. ",
      "phb":"Rich in dietary fiber, Supports weight management, Aids digestion, Regulates blood sugar levels, Provides sustained energy, Gluten-free, Supports bone health, Boosts lactation in nursing mothers, Promotes heart health.",
      "nutri":"Carbohydrates, Dietary fiber, Protein, Calcium, Iron, Magnesium, Phosphorus, Potassium, Vitamin B1 (Thiamine), Vitamin B2 (Riboflavin), Vitamin B3 (Niacin), Vitamin B6 (Pyridoxine), Folate, Vitamin E, Antioxidants"
    },
    {
      "id":7,
      "image":img7 ,
      "name":"Ragi Jaava",
      "description": "A very popular summer beverage made from healthy organic ragi flour and butter milk.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"To prepare Ragi Java, combine ragi (finger millet) flour with water, stirring continuously to avoid lumps. Heat the mixture until it thickens, then add hot water and cook until it reaches a porridge-like consistency. Season with salt, and optionally, add ghee for flavor.",
         "phb":"Rich in Dietary Fiber, High in Calcium, Good Source of Iron, Boosts Immunity, Supports Weight Loss, Regulates Blood Sugar Levels, Provides Essential Amino Acids",
         "nutri":"Dietary Fiber, Calcium, Iron, Protein, Vitamin C, Essential Amino Acids, Antioxidants, Magnesium, Zinc, B Vitamins (B1, B2, B3, B6)"
    },
    {
      "id":8,
      "image":img8 ,
      "name":"Oats Porridge Salted",
      "description": "A thick beverage made from parboiled oats and butter milk. A refreshing drink for summer.",
      "fat": "0",
      "sodium": "0",
      "proteins": "0",
      "carbs": "0",
      "des":"To make a quick and nutritious Salted Oats Porridge, combine rolled oats with water or milk in a saucepan and bring to a boil. Add a pinch of salt for flavor. Stir continuously until the oats reach a creamy consistency.",
      "phb":"Helps in Weight Management, Manages Blood Sugar Levels, Provides Sustained Energy, Enhances Digestive Health, Contains Essential Vitamins and Minerals, Boosts Immune System, Source of Antioxidants, Rich in Fiber, Supports Heart Health.",
      "nutri":"Fiber, Protein, Healthy Fats, Beta-Glucans, Iron, Magnesium, Phosphorus, Zinc, B Vitamins (B1, B2, B3, B6), Vitamin E, Calcium, Potassium"
    },
  ]
  

  export default FoodData;